import React from "react";
import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useProviderEmailPurposes } from "../hooks/useProviderEmailPurposes";

const ProviderEmailPurposeField = ({
  form,
  name,
  value,
  label,
  disabled,
  readOnly,
  placeholder,
}) => {
  const { t } = useTranslation();
  const current = value == null || value === "-" ? "" : value;
  const { options } = useProviderEmailPurposes(current);
  const translatedOptions = options.map((option) => ({
    ...option,
    label: option.label ? t(option.label) : option.label,
  }));

  return (
    <Select
      label={label || t("Email purpose")}
      placeholder={placeholder || t("Counts as General when empty")}
      data={translatedOptions}
      value={current || null}
      clearable
      withinPortal
      disabled={disabled || readOnly}
      styles={{ dropdown: { minWidth: 240 } }}
      onChange={(next) => {
        form?.setFieldValue?.(name, next || "");
      }}
    />
  );
};

export default ProviderEmailPurposeField;
